import React from "react";
import { Container } from "@mui/material";
import { Box } from "../../../design-system";
import { colors } from "../../../design-system/colors";
import LearningContent from "./LearningContent";
import LearningImageWithButton from "./LearningImageWithButton";

interface LearningCenterSectionProps {
  onCTAClick: () => void;
  titleFontSize?: { xs: string; md: string };
  titleMaxWidth?: string;
  subtitleFontSize?: { xs: string; md: string };
  subtitleMaxWidth?: string;
}

const LearningCenterSection: React.FC<LearningCenterSectionProps> = ({
  onCTAClick,
  titleFontSize,
  titleMaxWidth,
  subtitleFontSize,
  subtitleMaxWidth,
}) => {
  return (
    <Box
      component="section"
      id="learning-center"
      aria-label="Learning center section"
      sx={{
        backgroundColor: colors.background[850],
        mt: "80px",
        py: { xs: "3rem", md: "5rem" },
      }}
    >
      <Container maxWidth="lg">
        <LearningContent
          titleFontSize={titleFontSize}
          titleMaxWidth={titleMaxWidth}
          subtitleFontSize={subtitleFontSize}
          subtitleMaxWidth={subtitleMaxWidth}
        />
        <LearningImageWithButton onCTAClick={onCTAClick} />
      </Container>
    </Box>
  );
};

export default LearningCenterSection;
